<div class="report-wrap">
  <child-info-titlebar class="report-box-titlebar"
    (onChildChanged)="onChildChanged($event)"></child-info-titlebar>
  <div class="report-main-contents">
    <child-info-level
      class="report-box-level"
      [progress]="exerciseProgress">
    </child-info-level>
     <child-info-brain class="report-box-brain"
      [bleft]="bleft"
      [bright]="bright"
      [date]="latestCheckupDate"></child-info-brain>
  </div>
  <child-info-packet-summary class="report-box-packet"
    [centerName]="g.child"
    [packet]="packet"></child-info-packet-summary>
</div>
